module.exports = __webpack_public_path__ + "img/News_d4.6178641d.png";